const styles = ({ breakpoints }) => ({
  chatContactWrapper: {
    padding: '0 16px',
  },
  title: {
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '22px',
    paddingBottom: '8px',
    [breakpoints.up('sm')]: {
      fontSize: '21px',
      lineHeight: '26px',
    },
  },
  text: {
    fontSize: '12px',
    lineHeight: '16px',
    [breakpoints.up('sm')]: {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  link: {
    cursor: 'pointer',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: '700',
    color: '#0031FF',
    marginTop: '20px',
    padding: '2px 0',
    display: 'flex',
    alignItems: 'center',
    [breakpoints.up('sm')]: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  icon: {
    marginLeft: '8px',
  },
});

export default styles;
